export default function delay(ms){
  return new Promise(function(resolve) {
    setTimeout(()=>{resolve()}, ms)
  });
}



// WEBPACK FOOTER //
// ./src/Utils/Delay.js